import type { CloudRestoreHistory } from "@board-preserve/contracts";

type RestoreSummary = CloudRestoreHistory["restores"][number];

export function newestRestoreReports(
  reports: readonly RestoreSummary[],
): RestoreSummary[] {
  return [...reports].sort(
    (left, right) =>
      new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime(),
  );
}

export function visibleRestoreReports(
  reports: readonly RestoreSummary[],
  expanded: boolean,
  compactLimit = 4,
): RestoreSummary[] {
  const newest = newestRestoreReports(reports);
  return expanded ? newest : newest.slice(0, compactLimit);
}

export function nextRestoreReportJobId(
  currentJobId: string | null,
  selectedJobId: string,
): string | null {
  return currentJobId === selectedJobId ? null : selectedJobId;
}

export function restoreReportDisclosureLabel(
  expanded: boolean,
  loading: boolean,
): "Collapse report" | "Loading…" | "View report" {
  if (loading) return "Loading…";
  return expanded ? "Collapse report" : "View report";
}
